import { render, staticRenderFns } from "./releaseFirmwareDialog.vue?vue&type=template&id=0229ba85&scoped=true&"
import script from "./releaseFirmwareDialog.vue?vue&type=script&lang=js&"
export * from "./releaseFirmwareDialog.vue?vue&type=script&lang=js&"
import style0 from "./releaseFirmwareDialog.vue?vue&type=style&index=0&id=0229ba85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229ba85",
  null
  
)

export default component.exports